import React, { forwardRef } from 'react'

type IconButtonProps = {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  iconClass: string
  title?: string
  className?: string
  style?: React.CSSProperties
  id?: string
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ onClick, iconClass, title, className, style, id }, ref) => {
    return (
      <button
        id={id}
        type="button"
        title={title}
        className={`unstyled-button ${className}`}
        onClick={(event) => onClick(event)}
        ref={ref}
        style={style}
      >
        <i className={`${iconClass}`} />
      </button>
    )
  }
)

export default IconButton
